import React from 'react';
import { useNavigate } from 'react-router-dom';
import CreditCardForm from './CreditCardForm';
import './styles/invoicePayment.css';

const InvoicePayment = () => {
  const navigate = useNavigate();

  const handleCreditCardSubmit = (cardData) => {
    // Navigate directly to processing payment with invoice payment flag
    navigate('/processing-payment', {
      state: {
        paymentData: {
          cardData
        },
        paymentType: 'invoice'
      }
    });
  };

  const handleBackToPricing = () => {
    navigate('/');
  };

  return (
    <div className="invoice-payment-page">
      <div className="invoice-payment-container">
        <button
          className="back-button"
          onClick={handleBackToPricing}
        >
          ← Back to Plans
        </button>

        <div className="invoice-payment-header">
          <h1>Pay Invoice</h1>
          <p>Enter your payment details below</p>
        </div>

        <div className="invoice-payment-form">
          <h3>Payment Information</h3>
          <CreditCardForm onSubmit={handleCreditCardSubmit} showInvoiceFields={true} />
        </div>
      </div>
    </div>
  );
};

export default InvoicePayment;